import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { FormAutomation } from "src/app/form/form-automation";
import { ActionService } from "src/app/services/action.service";

@Component({
  selector: "app-execute-password-reset",
  templateUrl: "./execute-password-reset.component.html",
  styleUrls: [
    "./execute-password-reset.component.scss",
    "../../login/login.component.scss",
    "../../template/template.component.scss",
  ],
})
export class ExecutePasswordResetComponent implements OnInit {
  private key: string;
  isKeyValid = false;
  isKeyLoaded = false;
  resetExecuted = false;
  FormAutomation = FormAutomation;

  constructor(
    private route: ActivatedRoute,
    private dataService: ActionService,
  ) {
    this.route.params.subscribe(async (params: any[]) => {
      this.key = params["key"];
      setTimeout(() => {
        this.dataService.isPasswordKeyValid(this.key).then((e) => {
          this.isKeyValid = e;
          this.isKeyLoaded = true;
        });
      }, 500);
    });
  }

  ngOnInit(): void {}

  password1: string = "";
  password2: string = "";

  async submit() {
    await this.dataService.resetPassword({
      password: this.password1,
      key: this.key,
    });
    this.resetExecuted = true;
  }

  hasSpecialCharacter() {
    return /[^a-zA-Z0-9\s]/.test(this.password1);
  }
  hasUpperCaseCharacter() {
    return /[A-Z]/.test(this.password1);
  }
}
